<ngx-stripe-card-group *ngIf="model && paymentMethod && paymentMethod.type.indexOf('CreditCard') !== -1 && paymentMethod.value === 'new-credit-card'"
                       [formGroup]="model"
                       [elementsOptions]="elementsOptions"
>
    <div class="row">
        <div class="col-12" [class.col-lg-6]="!doStackColumns">
            <div class="card">
                <div class="card-header"><h2>Billing address</h2></div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-8 col-12">
                            <div class="form-group">
                                <label>
                                    Address: *
                                </label>
                                <input
                                    formControlName="address1"
                                    class="form-control"
                                    required
                                    name="address1"
                                    type="text"/>
                                <span class="error" *ngIf="isFieldInvalid('address1')">{{requiredError}}</span>
                            </div>
                        </div>
                        <div class="col-md-4 col-12">
                            <div class="form-group">
                                <label>
                                    Address 2:
                                </label>
                                <input
                                    formControlName="address2"
                                    name="address2"
                                    class="form-control"
                                    type="text"/>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 col-12">
                            <div class="form-group">
                                <label>
                                    City: *
                                </label>
                                <input
                                    formControlName="city"
                                    class="form-control"
                                    name="city"
                                    required
                                    type="text"/>
                                <span class="error" *ngIf="isFieldInvalid('city')">{{requiredError}}</span>
                            </div>
                        </div>
                        <div class="col-md-3 col-12">
                            <div class="form-group">
                                <label>
                                    State: *
                                </label>
                                <lf-geo-region-selector
                                    formControlName="region"
                                    ngDefaultControl
                                ></lf-geo-region-selector>
                                <span class="error" *ngIf="isFieldInvalid('region')">{{requiredError}}</span>
                            </div>
                        </div>
                        <div class="col-md-3 col-12">
                            <div class="form-group">
                                <label>
                                    Zip Code: *
                                </label>
                                <input
                                    formControlName="zip"
                                    class="form-control"
                                    name="zip"
                                    required
                                    type="text"/>
                                <span class="error" *ngIf="isFieldInvalid('zip')">{{requiredError}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12" [class.col-lg-6]="!doStackColumns">
            <div class="card mb-0">
                <div class="card-header d-flex justify-content-between align-items-center">
                    <h2>Card information</h2>
                    <a class="mr-3 mt-2" href="https://stripe.com" target="_blank">
                        <img class="stripe-icon" src="/assets/images/app/bank-logos/powered-by-stripe-300x68.png">
                    </a>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-6 col-12">
                            <div class="form-group">
                                <label>
                                    Name on card: *
                                </label>
                                <input
                                    formControlName="cardholderName"
                                    class="form-control"
                                    name="cardholderName"
                                    required
                                    type="text"/>
                                <span class="error" *ngIf="isFieldInvalid('cardholderName')">{{requiredError}}</span>
                            </div>
                        </div>
                        <div class="col-md-6 col-12">
                            <div class="form-group">
                                <label>
                                    Email Address: *
                                </label>
                                <input formControlName="email"
                                       class="form-control" required
                                       name="emailAddress"
                                       type="text" validateEmail/>
                                <span class="error" *ngIf="isFieldInvalid('email')">Please enter a valid email address.</span>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-lg-6 col-12">
                            <div class="form-group">
                                <label>
                                    Card Number: *
                                </label>
                                <ngx-stripe-card-number [options]="cardOptions"
                                                        (change)="onCardChange($event)"></ngx-stripe-card-number>
                                <div class="error" *ngIf="cardError || isCardEmpty === true">
                                    {{cardErrorString}}
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3 col-6">
                            <div class="form-group">
                                <label>
                                    Expires: *
                                </label>
                                <ngx-stripe-card-expiry [options]="cardOptions" (change)="onExpiryChange($event)"></ngx-stripe-card-expiry>
                                <div class="error" *ngIf="expiryError || isExpiryEmpty === true">
                                    {{expiryErrorString}}
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3 col-6">
                            <div class="form-group">
                                <label>
                                    CVC: *
                                </label>
                                <ngx-stripe-card-cvc [options]="cardOptions" (change)="onCvcChange($event)"></ngx-stripe-card-cvc>
                                <div class="error" *ngIf="cvcError || isCvcEmpty === true">
                                    {{cvcErrorString}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer text-right">
                    <button [attr.aria-label]="'save credit card'" class="btn btn-primary" [disabled]="isSaving" (click)="onSubmit()">
                        <i class="fa fa-plus-circle"></i>
                        {{buttonText}}
                    </button>
                </div>
            </div>
        </div>
    </div>

</ngx-stripe-card-group>
